import { actionTypes as firebaseActionTypes } from 'react-redux-firebase';
import { actionTypes as firestoreActionTypes } from 'redux-firestore';

import { SUBMIT_RESET } from '../actions/submit';

const {
  ADD_FAILURE,
  ADD_REQUEST,
  ADD_SUCCESS,
  UPDATE_REQUEST,
  UPDATE_SUCCESS,
  UPDATE_FAILURE,
} = firestoreActionTypes;
const { FILE_UPLOAD_START } = firebaseActionTypes;

const initialState = {
  hasFailed: false,
  isRequesting: false,
  isSuccessful: false,
};

const submit = (state = initialState, action) => {
  switch (action.type) {
    case ADD_REQUEST:
    case FILE_UPLOAD_START:
    case UPDATE_REQUEST:
      return {
        hasFailed: false,
        isRequesting: true,
        isSuccessful: false,
      };
    case ADD_SUCCESS:
    case UPDATE_SUCCESS:
      return {

        hasFailed: false,
        isRequesting: false,
        isSuccessful: true,
      };
    case ADD_FAILURE:
    case UPDATE_FAILURE:
      return {
        hasFailed: true,
        isRequesting: false,
        isSuccessful: false,
      };
    case SUBMIT_RESET:
      return initialState;
    default:
      return state;
  }
};

export default submit;



// WEBPACK FOOTER //
// ./src/redux/reducers/submit.js